var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetinHizalamaKenarlara(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "16px",
    viewBox: "0 0 22 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MetinHizalama-Kenarlara") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KIT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementler-KIT",
    transform: "translate(-1371.000000, -2886.000000)",
    fill: "#464646"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1385.08,2900.08 C1385.56601,2900.08 1385.96,2900.47399 1385.96,2900.96 C1385.96,2901.44601 1385.56601,2901.84 1385.08,2901.84 L1371.88,2901.84 C1371.39399,2901.84 1371,2901.44601 1371,2900.96 C1371,2900.47399 1371.39399,2900.08 1371.88,2900.08 L1385.08,2900.08 Z M1392.12,2895.38667 C1392.60601,2895.38667 1393,2895.78066 1393,2896.26667 C1393,2896.75268 1392.60601,2897.14667 1392.12,2897.14667 L1371.88,2897.14667 C1371.39399,2897.14667 1371,2896.75268 1371,2896.26667 C1371,2895.78066 1371.39399,2895.38667 1371.88,2895.38667 L1392.12,2895.38667 Z M1392.12,2890.69333 C1392.60601,2890.69333 1393,2891.08732 1393,2891.57333 C1393,2892.05934 1392.60601,2892.45333 1392.12,2892.45333 L1371.88,2892.45333 C1371.39399,2892.45333 1371,2892.05934 1371,2891.57333 C1371,2891.08732 1371.39399,2890.69333 1371.88,2890.69333 L1392.12,2890.69333 Z M1392.12,2886 C1392.60601,2886 1393,2886.39399 1393,2886.88 C1393,2887.36601 1392.60601,2887.76 1392.12,2887.76 L1371.88,2887.76 C1371.39399,2887.76 1371,2887.36601 1371,2886.88 C1371,2886.39399 1371.39399,2886 1371.88,2886 L1392.12,2886 Z",
    id: "MetinHizalama-Kenarlara"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetinHizalamaKenarlara);
export default __webpack_public_path__ + "static/media/MetinHizalama-Kenarlara.e19337badc4a3b67ec2b820bb6c780e3.svg";
export { ForwardRef as ReactComponent };